import { render, staticRenderFns } from "./PositionCreationAssistant.vue?vue&type=template&id=77bf2437&scoped=true"
import script from "./PositionCreationAssistant.vue?vue&type=script&lang=js"
export * from "./PositionCreationAssistant.vue?vue&type=script&lang=js"
import style0 from "./PositionCreationAssistant.vue?vue&type=style&index=0&id=77bf2437&prod&scoped=true&lang=css"
import style1 from "./PositionCreationAssistant.vue?vue&type=style&index=1&id=77bf2437&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf2437",
  null
  
)

export default component.exports